import {
  formatBrazilianPhoneNumber,
  formatCNPJ,
  formatUUID,
} from "utils/formatters";

import { PIX } from "../models/PIX";

export function getPixFormattedValue({ type, value }: PIX) {
  return {
    randomKey: formatUUID(value),
    cnpj: formatCNPJ(value),
    phoneNumber: formatBrazilianPhoneNumber(value),
    email: value,
  }[type];
}
